import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorCircleNew16 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "#F03040"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.70581 4.70605L11.294 11.2943M4.70598 11.2943L11.294 4.70605",
		stroke: "white",
		strokeWidth: 2
	})]
});
export default SvgErrorCircleNew16;
